import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=96a987b6"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryList: require('/opt/build/repo/components/category/List.vue').default,SectionBase: require('/opt/build/repo/components/section/Base.vue').default})
